/**
 * @module FE-CU54_Thanks画面
 */
import Header from '@/components/header/Header.vue';
import MailConfirmation from './displayPattern/MailConfirmation.vue';
import SimpleConfirmation from './displayPattern/SimpleConfirmation.vue';
import ServiceAddConfirmation from './displayPattern/ServiceAddConfirmation.vue';
import ExpiredUrlConfirmation from './displayPattern/ExpiredUrlConfirmation.vue';
import PasswordLockConfirmation from './displayPattern/PasswordLockConfirmation.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU54';

export default {
  name: 'Thanks',
  components: {
    Header,
    MailConfirmation,
    SimpleConfirmation,
    ServiceAddConfirmation,
    ExpiredUrlConfirmation,
    PasswordLockConfirmation,
    PCFooter,
  },
  data() {
    return {
      fromPageInfo: this.$store.state.thanks.fromPageInfo, // 遷移元の情報を格納する（どのようなデータを入れればいいかは未定）
      displayType: Number(this.$store.state.thanks.displayType), // 遷移元によって出し分ける
      // 1: 新規メインユーザー登録画面(仮登録)、パスワード初期化画面(ユーザーID入力)、メインユーザー移譲画面、ユーザー情報変更画面(メールアドレス)からの遷移時
      // 2: アカウント削除画面、ユーザー登録画面(本登録(メイン/サブ))、パスワード初期化画面(パスワード再登録)からの遷移時
      // 3: サービス追加画面からの遷移時
      // 4: パスワード初期化(秘密の質問)画面で秘密の質問の回答を一定回数間違えてアカウントがロックされた場合
      // 5: ・失効したワンタイムURLにアクセスした場合
    };
  },
  /** @type {Methods} */
  methods: {},
  mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
  },
};
